import { CanActivateFn, Router } from '@angular/router';
import { AUTH_SERVICE, AuthService } from '../services/auth.service';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = async (route, state) => {

  const authService: AuthService = inject(AUTH_SERVICE);
  const router: Router = inject(Router);
  if(await authService.isLoggedIn()) {
    return true
  }else{
    router.navigate(['/login']);
    return false;
  }

};
